import React from 'react';
import styled, { useTheme } from 'styled-components';
import { breakpoint } from '../styling/mixins/breakpoints';
import { getColor } from '../styling/mixins/colors';
import Checkbox from './Inputs/Checkbox';
import Input from './Inputs/Input';
import RadioButton from './Inputs/Radiobutton';
import TextArea from './Inputs/TextArea';
import FilterRangeSlider from './ProductFiltering/FilterOptions/FilterRangeSlider';
import { FilterGroupType } from './ProductFiltering/types/FilterGroupType';

const Wrapper = styled.div`
  background-color: ${(props) => props.color};
  color: ${(props) => props.theme.colors.primary};
  font-size: 32px;
  padding: 0 120px;

  .xD {
    background-color: cyan;
  }
`;

const StyledSpan = styled.span`
  background-color: ${getColor('grey', 800)};
  ${breakpoint('large')} {
    background-color: red;
  }
`;

const Test = ({ color }: { color: string }) => {
  return (
    <Wrapper color={color}>
      <StyledSpan className="hide-for-large xD">
        Test
      </StyledSpan>
      <button
        className="btn btn--primary btn--large"
        onClick={() => alert('Du klickade!')}
      >
        Testknapp!
      </button>
      <FilterRangeSlider
        filter={{
          id: 'test',

          label: 'test',

          singleSelect: false,

          options: [
            { label: '0', id: '0', quantity: 1 },

            { label: '100', id: '100', quantity: 1 },
          ],

          selectedOptions: [],

          filterGroupType: FilterGroupType.Range,

          showSearch: false,
        }}
      />
      <Input
        inputSize="small"
        inputState="error"
        icon="user"
        wrapperClassName="xD"
        label="xD"
        message="Ett fel uppstod!"
        helperText="skriv nåt här"
      />
      <TextArea
        inputSize="small"
        inputState="success"
        icon="shopping-cart"
        label="xD"
        message="Det gick bra!"
        helperText="Här är lite hjälp"
      />
      <Checkbox inputSize="large" />
      <RadioButton inputSize="large" name="xd" />
      <RadioButton inputSize="large" name="xd" label="xD" />
    </Wrapper>
  );
};

export default Test;
